export const HOST_SALON_MIN_DATE = new Date(2024, 4, 1, 0, 0, 0);
export const HOST_SALON_MAX_DATE = new Date(2024, 4, 9, 0, 0, 0);

export const HOST_SALON_OPEN_REGISTRATION_DATE = new Date(2024, 4, 5, 19, 0, 0);

export const ADD_WITNESS_MIN_DATE = new Date(1900, 0, 1, 0, 0, 0);
export const ADD_WITNESS_MAX_DATE = new Date();

export const OPEN_TO_DATE = new Date(null);

export const DISABLED_DAYS = [
  {
    after: new Date(2024, 4, 9),
    before: new Date(2024, 4, 1),
  },
];

export const availableDates = [
  { label: "2024-04-01", date: new Date(2024, 4, 1) },
  { label: "2024-04-02", date: new Date(2024, 4, 2) },
  { label: "2024-04-04", date: new Date(2024, 4, 4) },
  { label: "2024-04-05", date: new Date(2024, 4, 5) },
  { label: "2024-04-06", date: new Date(2024, 4, 6) },
  { label: "2024-04-07", date: new Date(2024, 4, 7) },
  { label: "2024-04-08", date: new Date(2024, 4, 8) },
  { label: "2024-04-09", date: new Date(2024, 4, 9) },
];
